import { api } from '../../DefaultService';
import {
  IHomeAssistantScheduleCreateProps,
  IHomeAssistantScheduleProps,
  IHomeAssistantScheduleUpdateParams,
} from './types';

const ENDPOINT = '/v1/devices/home-assistant/schedules';

export const getAllHomeAssistantSchedulesByLicenseAsync = async (): Promise<
  IHomeAssistantScheduleProps[]
> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const createHomeAssistantScheduleAsync = async (
  data: IHomeAssistantScheduleCreateProps,
): Promise<IHomeAssistantScheduleProps> => {
  return await api
    .post(`${ENDPOINT}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateHomeAssistantScheduleAsync = async ({
  id,
  data,
}: IHomeAssistantScheduleUpdateParams): Promise<IHomeAssistantScheduleProps> => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteHomeAssistantScheduleAsync = async (
  id: number,
): Promise<void> => {
  await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
